<template>
    <div>
        <bs-card class="card-info">
            <bs-table v-bind="{dataLength, loading}" :cols="4">
                <template v-slot:thead>
                    <tr v-if="resourceState.search.active">
                        <th class="p-1" colspan="3">
                            <input type="text" class="form-control form-control-sm border-1 border-primary shadow-sm bg-light" v-model="searchPhrase">
                        </th>
                        <th class="text-right"><bs-action :icon="['fas', 'times']" class="btn-outline-secondary" @click="applySearch({active: false, phrase: ''})"></bs-action></th>
                    </tr>
                    <tr v-else>
                        <bs-th :label="$t('labels.label')" :sortable="resourceState.sort" :col="'label'" @click="applySort"></bs-th>
                        <bs-th :label="$t('labels.description')"></bs-th>
                        <bs-th :label="$t('labels.consumable')" class="text-center"></bs-th>
                        <th class="text-right"><bs-action :icon="['fal', 'search']" class="btn-outline-secondary" @click="applySearch({active: true, phrase: ''})"></bs-action></th>
                    </tr>
                </template>
                <tr v-for="r in resources.data" :key="r.id">
                    <td>{{ r.label }}</td>
                    <td>{{ r.description }}</td>
                    <td class="text-center">
                        <fa-icon v-if="r.consumable" :icon="['fal', 'check']" />
                    </td>
                    <td class="t2">
                        <bs-action v-if="auth.can['edit_tasks']" :icon="['fal', 'pencil']" :tip="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.edit') })" class="btn-info" @click="update(r)"></bs-action>
                        <bs-action v-if="auth.can['edit_tasks']" :icon="['fal', 'trash']" :tip="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.destroy') })" class="btn-danger" @click="destroy(r)"></bs-action>
                    </td>
                </tr>
            </bs-table>
        </bs-card>
        <bs-modal :name="'create-' + $options.name" :label="$t('labels.action_' + camelToSnake(singular($options.name)), { action: resource.id ? $t('labels.edit') : $t('labels.create') })">
            <bs-form :submit="$t('labels.submit')" @submit="submit">
                <template v-slot:default="slotProps">
                    <tuxedo-input :name="'label'" :label="$t('labels.label')" v-model="resource.label" :help="$t('tips.label', { resource: $t('labels.task', {}, 1) })" :error="slotProps.error" />
                    <text-field :name="'description'" :label="$t('labels.description')" v-model="resource.description" :help="$t('tips.description')" :error="slotProps.error"></text-field>
                    <toggle-field :name="'consumable'" :label="$t('labels.consumable')" v-model="resource.consumable" :help="$t('tips.consumable')" :error="slotProps.error"></toggle-field>
                </template>
            </bs-form>
        </bs-modal>
        <bs-modal :name="'destroy-' + $options.name" :label="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.destroy') })">
            <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
                {{ $t('messages.delete', { resource: $t('labels.task', {}, 1) }) }}
            </bs-form>
        </bs-modal>
        <portal to="app-footer">
            <pagination :data="resources" :state="resourceState" @pushPage="index"></pagination>
        </portal>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'debounce'

export default {
  name: 'Tasks',
  data () {
    return {
      loading: false,
      activeId: null,
      resource: {
        label: '',
        description: '',
        consumable: false
      }
    }
  },
  mounted () {
    this.search = debounce(this.search, 500)
    this.index(this.resourceState.page)
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      resources: state => state.tasks,
      submitting: state => state.submitting,
      resourceState: state => state.tasksState
    }),
    dataLength () {
      let length = 0
      if (this.resources.data) length = this.resources.data.length
      return Math.max(this.resourceState.tableRows - length, 0)
    },
    searchPhrase: {
      get () {
        return this.resourceState.search.phrase
      },
      set (val) {
        this.applySearch({ active: true, phrase: val })
      }
    }

  },
  methods: {
    applySearch (val) {
      this.$store.commit('pushState', { view: this.$options.name, key: 'search', data: val })
      this.search()
    },
    search () { this.index(1) },
    applySort (val) {
      this.$store.commit('pushState', { view: this.$options.name, key: 'sort', data: val })
      this.index()
    },
    index (page, count) {
      if (page) this.$store.commit('pushState', { view: this.$options.name, key: 'page', data: page })
      if (count) this.$store.commit('pushState', { view: this.$options.name, key: 'tableRows', data: count })
      this.loading = true
      this.$store.dispatch('index', {
        collection: this.$options.name,
        data: {
          icon: ['fal', 'tasks']
        }
      }).then(() => {
        this.loading = false
      })
    },
    create () {
      this.$root.clearData(this.resource)
      this.$modal.show('create-' + this.$options.name)
    },
    destroy (o) {
      this.activeId = o.id
      this.$modal.show('destroy-' + this.$options.name)
    },
    update (o) {
      this.resource = JSON.parse(JSON.stringify(o))
      this.$modal.show('create-' + this.$options.name)
    },
    submit () {
      this.$store.dispatch(this.resource.id ? 'update' : 'store', { collection: this.$options.name, resource: this.resource }).then(() => {
        this.$modal.hide('create-' + this.$options.name)
      })
    },
    destruction () {
      this.$store.dispatch('destroy', { collection: this.$options.name, id: this.activeId }).then(() => {
        this.$modal.hide('destroy-' + this.$options.name)
      })
    }
  }
}
</script>
